<template>
  <Command @click="mediaPlayer?.next()">
    <slot
      v-bind="{
        disabled: !mediaPlayer || !mediaPlayer.can('next'),
        icon: 'skip_next',
        label: t('tts.controls.skipNext'),
        toolTip: t('tts.controls.skipNext'),
      }"
    />
  </Command>
</template>
<script setup lang="ts">
import { inject, Ref } from "vue";
import { useI18n } from "vue-i18n";

import Command from "../command";
import MediaPlayer from "@/services/media/player";

const { t } = useI18n();

const mediaPlayer = inject("mediaPlayer") as Ref<MediaPlayer | null>;
</script>
